import { Flex, FlexProps } from '../../../../atoms';

export function OutletHeaderExtra(props: FlexProps): JSX.Element {
  return <Flex flexDir="column" {...props} />;
}
